import type { ExternalReferenceEntitiesMap } from '../../../services/atlas/types.tsx';
import { getAllExternalReferenceEntities } from './external-reference.tsx';
import { createIssueHook } from './utils.tsx';

export const useAllExternalReferenceEntities = createIssueHook<ExternalReferenceEntitiesMap>(
	getAllExternalReferenceEntities,
);
